import { Brand } from '@fanduel/cpe-um-bundle/core-config/contract';
import { Buffer } from 'buffer';
import config from '@/config';
import {
  BRAND,
  COUNTRY,
  COUNTRY_ABBREVIATION,
  ENVIRONMENT,
  qaEnvsUSA,
} from '../constants/account';

export const getBrandUM = (brand: string): Brand => {
  if (brand === BRAND.MOHEGANSUN) {
    return Brand.MoheganSun;
  }
  return Brand.FanDuel;
};

export const getCountry = (country: string) => {
  if (country === COUNTRY.CANADA) {
    return COUNTRY_ABBREVIATION.CANADA;
  }
  return COUNTRY_ABBREVIATION.USA;
};

export const getEnvironment = () => {
  const env = config.env;
  if (env === ENVIRONMENT.PROD) {
    return ENVIRONMENT.PROD;
  }

  return process.env.COUNTRY === COUNTRY.CANADA ||
    qaEnvsUSA.includes(env) ||
    config.domain?.includes('qa.canada')
    ? ENVIRONMENT.QA
    : ENVIRONMENT.CERT;
};

export const getDecodedClientID = (clientId: string) =>
  Buffer.from(clientId, 'base64').toString('utf-8');
